export default "__VITE_ASSET__CF7R0_lN__"